import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var GuestGeneralInfoService = /** @class */ (function () {
    function GuestGeneralInfoService(http) {
        this.http = http;
        this.server = "" + environment.server;
    }
    GuestGeneralInfoService.prototype.getReferralSummary = function (profileId) {
        return this.http.get(this.server + "/api/pool-manager/profiles/" + profileId + "/referrals/summary").pipe(catchError(this.handleError));
    };
    GuestGeneralInfoService.prototype.getGuestDetails = function (id) {
        return this.http.get(this.server + "/api/getGuestDetails/" + id).pipe(catchError(this.handleError));
    };
    GuestGeneralInfoService.prototype.getLifetimeRides = function (profileId) {
        return this.http.get(this.server + "/api/customer-service/profiles/" + profileId + "/lifetime-rides").pipe(catchError(this.handleError));
    };
    GuestGeneralInfoService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    GuestGeneralInfoService.ngInjectableDef = i0.defineInjectable({ factory: function GuestGeneralInfoService_Factory() { return new GuestGeneralInfoService(i0.inject(i1.MyHttpClient)); }, token: GuestGeneralInfoService, providedIn: "root" });
    return GuestGeneralInfoService;
}());
export { GuestGeneralInfoService };
